import React, { useEffect, useRef, useState } from "react";
import {
  Modal,
  ModalBody,
  Card,
  CardBody,
  Row,
  Col,
  Container,
} from "reactstrap";
import Chart from "../../../../assets/images/CHPT/chart.png";
import ChartParty from "../../../../assets/images/CHPT/charity-party-large.png";
import LargeVector from "../../../../assets/images/CHPT/largeVector.png";
import ChartyPartyCards from "../../../../assets/images/CHPT/chartyParty.png";
import { compose } from "redux";
import { withSocket } from "../../../../socket/context";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";
import Players from "../players";

const FlippedCardView = (props) => {
  const roomData = _.get(props, "gameReducer.roomObj");
  const playerCards = _.get(roomData, "game_state.played_cards");
  const prevPlayerCards = useRef(null);
  const [flippedCard, setFlippedCard] = useState(null);
  const prompt = _.get(roomData, "game_state.prompt");

  useEffect(() => {
    if (prevPlayerCards.current) {
      const prevPlayerHands = prevPlayerCards.current;
      const newPlayerHands = playerCards;
      if (JSON.stringify(prevPlayerHands) === JSON.stringify(newPlayerHands))
        return;
      else {
        prevPlayerHands.map((item) => {
          newPlayerHands.map((element) => {
            if (
              element.card.id === item.card.id &&
              element.flipped !== item.flipped
            ) {
              setFlippedCard(element);
            }
          });
        });
      }
    }
    prevPlayerCards.current = playerCards;
  }, [playerCards]);

  return (
    <div className="charity-modal">
      <Row className="h-100 mx-0">
        <Col md={4}>
          <div className="chptPlayingCard text-right">
            {flippedCard === null ? (
              <div className="img-container">
                <img src={ChartyPartyCards} />
              </div>
            ) : (
              <img
                src={flippedCard.card.url}
                alt="charty-party"
                className="modal-flipped-image"
              />
            )}
          </div>
        </Col>
        <Col md={5}>
          <div className="chpt-modal-card1">
            <div className="d-flex align-items-center h-100">
              <div className="charity-image">
                <img src={prompt?.url} alt="chart" />
              </div>
            </div>
          </div>
          <div className="chpt-modal-card2">
            <div className="cards-view-wrapper">
              <div className="cards-view">
                {playerCards.map((card) => {
                  if (!card.flipped) {
                    return <img src={ChartyPartyCards} alt="" />;
                  }
                })}
              </div>
            </div>
          </div>
        </Col>
        <Col md={3}>
          <div className="chpt-card-reading">
            <div className="chpt-card">
              <Players roomData={roomData} />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default compose(
  withRouter,
  withSocket,
  connect(mapStateToProps, mapDispatchToProps)
)(FlippedCardView);
